import {Box, Modal, Typography, Paper, IconButton} from "@mui/material";
import DoneOutlineOutlinedIcon from '@mui/icons-material/DoneOutlineOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';


import CloseIcon from "@mui/icons-material/Close";
import PageButtonBlue from "./PageButtonBlue";
import PageButtonBlack from "./PageButtonBlack";
import PageButtonWhite from "./PageButtonWhite";

export default function ModalStandardCancel(props) {

    return (
		<Modal
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.05)",
        }}
        slotProps={{ backdrop: { sx: { opacity: "0.1!important" } } }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "749px",
            height: "261px",
            backgroundSize: "background.paper",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            outline: 0,
          }}
        >
          <Paper elevation={3} sx={{ padding: 3, textAlign: "center" }}>
            <IconButton
              sx={{ position: "absolute", top: 8, right: 8 }}
              onClick={props.onClose}
            >
              <CloseIcon />
            </IconButton>

            <Box>
              <Box>
        {props.icon ? (
          props.icon
        ) : props.error ? (
          <WarningAmberIcon color="error" sx={{ fontSize: 45 }} />
        ) : (
          <DoneOutlineOutlinedIcon color="success" sx={{ fontSize: 45 }} />
        )}
				</Box>
            </Box>
            <Typography
              variant="h5"
              component="h1"
              fontWeight="bold"
              color="textPrimary"
              gutterBottom
              sx={{
                fontSize: "1.625rem",
                lineHeight: "48px",
                margin: "0",
                color: "#4D4D4D",
              }}
            >
              {props.title}
            </Typography>

            <Box
              justifyContent="center"
              sx={{ maxWidth: "600px", margin: "0 auto", display: "flex", fontSize: "1.125rem", "fontFamily": "Roboto Slab", "color": "#111"}}
            >
              <Typography
                variant="h5"
                align="center"
                sx={{ marginBottom: 1,  fontWeight: "600" }}
              >
                {props.qst}
              </Typography>
            </Box>

            <Box
              justifyContent="center"
              sx={{ maxWidth: "500px", margin: "0 auto", display: "flex" }}
            >
              <Typography
                variant="body"
                align="center"
                sx={{ marginBottom: 2 }}
              >
                {props.msg}
              </Typography>
            </Box>


            <Box mt={2} display="flex" justifyContent="center">
              <Box mt={2} display="inline-flex" justifyContent="center" sx={{gap:2}}>
              <PageButtonWhite onClick={() => props.onClose()} width="150px"
                sx={{ borderRadius: 0 }}
              
              >
                Cancelar
              </PageButtonWhite>

              <PageButtonBlack onClick={props.onClick}
                sx={{ borderRadius: 0 }}
              >
                {props.btnText}
              </PageButtonBlack>
            </Box>
            </Box>

          </Paper>
        </Box>
      </Modal>
    );
}











      